// Imports
import { ComponentProps } from 'react';
import CardInner from '../../../integrations/api/components/fields/card';
import handleStripeError from '../utils/handle-stripe-error';


// Define the accepted props
type Props = Omit<ComponentProps<typeof CardInner>, 'onStripeError'>;


// Function component
const Card: React.FC<Props> = (props) => <CardInner onStripeError={handleStripeError} {...props} />;

export default Card;
